import AsientosList from './List.jsx';

export default function AsientosPage() {
  return <AsientosList />;
}
